<template>
	<div class="snackbar" :style="styleBar" v-if="isVisible">
		<slot></slot>
	</div>
</template>

<script>
	function styleBar() {
		return {
			'background-color': this.color,
			bottom: this.bottom ? '5px' : 'auto',
			left: this.left ? '5px' : 'auto',
			right: this.right ? '5px' : 'auto',
			top: this.top ? '5px' : 'auto',
		};
	}

	export default {
		name: 'app-snackbar',
		computed: {
			styleBar,
		},
		props: {
			color: String,
			isVisible: {
				default: false,
				type: Boolean,
			},
			right: {
				default: false,
				type: Boolean,
			},
			timeout: {
				default: 5000,
				type: Number,
			},
			top: {
				default: false,
				type: Boolean,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.snackbar {
		border-radius: 3px;
		box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, .5);
		color: map-get($colors, white);
		font-family: map-get($fonts, open-regular);
		font-size: 12px;
		padding: 15px;
		position: fixed;
		width: auto;
		z-index: 999;
		@include transition();
	}
</style>


// WEBPACK FOOTER //
// src/components/commons/app-snackbar.vue